import type { ProductTaxonomyRenameDefinition } from '../types';

export const profileActivityRename = {
  copy: {
    'nav.review.activityLogs': {
      current: 'Activity Logs',
      future: 'Profile activity',
    },
  },
  routes: {
    'profileActivity.index': {
      current: '/workspaces/:workspaceId/journeys/activity_logs',
      future: '/workspaces/:workspaceId/journeys/profile_activity/identified',
    },
    'profileActivity.identified': {
      current: '/workspaces/:workspaceId/journeys/activity_logs/identified',
      future: '/workspaces/:workspaceId/journeys/profile_activity/identified',
    },
  },
  sideNavItemIds: {
    logs: 'profile-activity',
  },
} as const satisfies ProductTaxonomyRenameDefinition;
